module.exports = __webpack_public_path__ + "static/media/iwmintranet.015106de.jpg";